<script lang="ts">
  import { onMount } from 'svelte';
  import { checkAccount, clearCustomClientId, customClientIdActive, handleCallback, SpotifyAuthError } from '../spotify/auth';
  import { hostHref } from '../lib/tvWindow';
  import InviteOnly from './InviteOnly.svelte';
  import OwnSpotifyApp from './OwnSpotifyApp.svelte';

  let refused = $state<'not_allowed' | 'not_premium' | null>(null);
  let failed = $state('');
  /** A login with the host's own Spotify app failed: most likely a setup mistake in their dashboard. */
  let customRejected = $state(false);
  let ownOpen = $state(false);

  function switchBack() {
    clearCustomClientId();
    location.replace(hostHref());
  }

  onMount(async () => {
    try {
      await handleCallback(location.href);
      const account = await checkAccount();
      if (account === 'ok') location.replace(hostHref());
      else refused = account;
    } catch (e) {
      if (e instanceof SpotifyAuthError && e.reason === 'not_allowed') refused = 'not_allowed';
      else {
        customRejected = customClientIdActive() && e instanceof SpotifyAuthError && e.rejected;
        failed = 'Spotify login did not finish. Please try again.';
      }
    }
  });
</script>

{#if refused}
  <InviteOnly reason={refused} />
{:else}
  <main>
    <h1 class="wordmark">BANGER!</h1>
    {#if customRejected}
      <p class="err">Spotify rejected the login. Check that the Redirect URI is exactly <code>{location.origin}/callback</code> and both APIs are checked, then try again.</p>
      <div class="row">
        <button class="btn-neon" onclick={() => (ownOpen = true)}>Edit Client ID</button>
        <button class="ghost" onclick={switchBack}>Switch back to default</button>
      </div>
      <a href={hostHref()}>Back to hosting</a>
    {:else if failed}
      <p class="err">{failed}</p>
      <a href={hostHref()}>Back to hosting</a>
    {:else}
      <p>Connecting to Spotify…</p>
    {/if}
  </main>
{/if}
{#if ownOpen}<OwnSpotifyApp onclose={() => (ownOpen = false)} />{/if}

<style>
  main { min-height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem; text-align: center; font-size: 1.6rem; }
  h1 { margin: 0; font-size: clamp(3rem, 10vw, 7rem); }
  p { margin: 0; }
  .err { color: #ff8fa3; font-weight: 700; max-width: 40ch; }
  .row { display: flex; flex-wrap: wrap; gap: 12px; justify-content: center; }
  .row button { font-size: 1.3rem; padding: 0.45em 1.4em; }
  .ghost {
    font-family: inherit; font-weight: 800; color: var(--cyan); cursor: pointer; border-radius: 999px;
    background: rgba(125, 249, 255, 0.08); border: 2px solid rgba(125, 249, 255, 0.5);
  }
</style>
